import { verifyPassword } from "./validate"

export function leftPad(str, len, pad = ' ') {
    if (!str) {
        str = ''
    }
    if (str.length >= len) {
        return str
    }
    while (str.length < len) {
        str = pad + str
    }
    return str
}

export function sleep(time) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, time * 1000)
    })
}

export function generateRandomString(length, characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789') {
    let str = '';
    for (let i = 0; i < length; i++) {
        str += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return str;
}

export function generateRandomPassword(length) {
    const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()-_=+[]{}|;:,.<>?/~'
    let str = generateRandomString(length, characters)
    while(!!verifyPassword(str)) {
        str = generateRandomString(length, characters)
    }
    return str
}

export const oaContractTypeMap = {
    '按签约核销时间': 'CHECK_TIME',
    '按签约库存总量': 'TOTAL_STOCK'
}
